// TODO: Fix eslint errors.
/* eslint-disable sonarjs/no-collapsible-if */
/* eslint-disable sonarjs/no-duplicate-string */
/* eslint-disable sonarjs/cognitive-complexity */
/* eslint-disable write-good-comments/write-good-comments */
/* eslint-disable no-param-reassign */
/* eslint-disable no-prototype-builtins */
/* eslint-disable no-shadow */
/* eslint-disable radix */
import React from 'react';
import { Helmet } from 'rnd-helmet';
import { injectIntl } from 'react-intl';
import HeaderText from '@UI/HeaderText';
import BlogFilter from '@Filters/Blog';
import SortBar from '@Components/SortBar';
import Pager from '@Components/Pager';
import Breadcrumbs from '@Components/Breadcrumbs';
import NoResults from '@Components/NoResults';
import Block from '@UI/Block';
import { Redirect, Route, useRouteMatch } from 'react-router-dom';
import { generateDataLayer } from 'dataLayerHelper';
import searchParamsStringify from '@Utils/searchParamsStringify';
import GetRouteFromUrl from 'GetRouteFromUrl';
import ArticleList from '@UI/ArticleOverview/List';
import { getCurrentCategoryName } from 'facetsHelper';
import NotFound from '@Pages/NotFound';
import withSearch from '../../components/hoc/Search';

function Career({
  intl, searchParams, pager, articles, total, canonicalOverrides, staticContext,
}) {
  const { locale } = intl;
  const route = useRouteMatch();
  const routeConfig = GetRouteFromUrl();
  const baseUrl = route.path.replace(':searchParams*', '');
  if (searchParams && searchParams.page && parseInt(searchParams.page) === 1) {
    return (
      <Route render={({ staticContext }) => {
        if (staticContext) staticContext.status = 301;
        return <Redirect to={`${baseUrl}${searchParamsStringify('career', { ...searchParams, ...{ page: null } })}`} />;
      }}
      />
    );
  }
  if (searchParams && searchParams.unknown) {
    return (
      <Route render={({ staticContext }) => {
        if (staticContext) staticContext.status = 404;
        return <NotFound staticContext={staticContext} />;
      }}
      />
    );
  }
  if (staticContext && staticContext.data) {
    // Pass the dataLayer to the server using staticContext.
    if (staticContext.appConfigurations
      && staticContext.appConfigurations.hasOwnProperty('rbd_tracking.settings')
      && staticContext.appConfigurations['rbd_tracking.settings'].gtm
      && staticContext.appConfigurations['rbd_tracking.settings'].gtm.enabled) {
      staticContext.dataLayer = generateDataLayer('other_content', locale);
    }
  }
  let metaTitle = intl.formatMessage({ id: 'Career.Title' }, { sitename: process.env.REACT_APP_SITENAME });
  let metaDescription = intl.messages['Career.MetaDescription'] ? intl.messages['Career.MetaDescription'] : null;
  let titleTop = intl.formatMessage({ id: 'CareerHeader.TitleTop' });
  let titleBottom = intl.messages['CareerHeader.TitleBottom'] ? intl.formatMessage({ id: 'CareerHeader.TitleBottom' }) : null;

  const categoryName = searchParams.facets ? getCurrentCategoryName(searchParams.facets) : '';
  if (categoryName.length) {
    metaTitle = intl.messages['Career.CategoryTitle'] ? intl.formatMessage({ id: 'Career.CategoryTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: categoryName,
    }) : metaTitle;
    metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle'] ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle' }, {
      sitename: process.env.REACT_APP_SITENAME,
      category: categoryName,
    }) : metaDescription;
    switch (categoryName) {
      case 'curriculum vitae':
        metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle.CurriculumVitae']
          ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle.CurriculumVitae' }, { sitename: process.env.REACT_APP_SITENAME })
          : metaDescription;
        break;
      case 'personal branding':
        metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle.PersonalBranding']
          ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle.PersonalBranding' }, { sitename: process.env.REACT_APP_SITENAME })
          : metaDescription;
        metaTitle = intl.messages['Career.CategoryTitle.PersonalBranding']
          ? intl.formatMessage({ id: 'Career.CategoryTitle.PersonalBranding' }, { sitename: process.env.REACT_APP_SITENAME })
          : metaTitle;
        break;
      case 'rentas':
        metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle.Rentas']
          ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle.Rentas' }, { sitename: process.env.REACT_APP_SITENAME })
          : metaDescription;
        break;
      default:
        metaDescription = intl.messages['Career.CategoryMetaDescriptionTitle'] ? intl.formatMessage({ id: 'Career.CategoryMetaDescriptionTitle' }, {
          sitename: process.env.REACT_APP_SITENAME,
          category: categoryName,
        }) : metaDescription;
        metaTitle = intl.messages['Career.CategoryTitle'] ? intl.formatMessage({ id: 'Career.CategoryTitle' }, {
          sitename: process.env.REACT_APP_SITENAME,
          category: categoryName,
        }) : metaTitle;
    }

    titleTop = intl.messages['CareerHeader.CategoryTitleTop'] ? intl.formatMessage({ id: 'CareerHeader.CategoryTitleTop' }, { category: categoryName }) : titleTop;
    titleBottom = intl.messages['CareerHeader.CategoryTitleTopBottom'] ? intl.formatMessage({ id: 'CareerHeader.CategoryTitleTopBottom' }) : titleBottom;
  }
  metaTitle = metaTitle.charAt(0).toUpperCase() + metaTitle.slice(1); // todo: this should be fixed when page is present

  if (searchParams.page && intl.messages['Global.Page']) {
    metaTitle = `${intl.formatMessage({ id: 'Global.Page' }, { page: searchParams.page })} ${metaTitle}`;
  }
  const searchParamsString = searchParamsStringify('career', searchParams);
  let canonicalLink = baseUrl + searchParamsString;
  // Page's canonical link, can be overridden,
  // from CMS configuration.
  if (canonicalOverrides && Object.keys(canonicalOverrides).length > 0) {
    let overrideValue;
    if (canonicalOverrides[canonicalLink]) {
      // First check for full match.
      overrideValue = canonicalOverrides[canonicalLink] ? canonicalOverrides[canonicalLink] : '';
    } else if (searchParams && searchParams.page) {
      const { page } = searchParams;
      searchParams.page = null;
      const noPager = baseUrl + searchParamsStringify('career', searchParams);
      searchParams.page = page;
      if (canonicalOverrides[noPager]) {
        const baseOverrideValue = canonicalOverrides[noPager];
        overrideValue = canonicalLink.replace(noPager, baseOverrideValue);
      }
    }
    if (canonicalOverrides[baseUrl] && overrideValue === undefined) {
      // Try to apply wildcard, for base path override.
      overrideValue = canonicalOverrides[baseUrl] + searchParamsString;
    }
    if (overrideValue && overrideValue.length > 1) canonicalLink = overrideValue;
  }

  return (
    <div id="articles-search-listing">
      <Helmet>
        <title>{metaTitle}</title>
        {metaDescription ? <meta name="description" content={metaDescription} /> : null}
        <link rel="canonical" href={`${process.env.REACT_APP_BASE_URL}${canonicalLink}`} />
      </Helmet>
      <Breadcrumbs breadcrumbs={routeConfig.breadcrumbs} currentRoute={route} searchParams={searchParams} pageType="career" />
      <HeaderText
        variation="blue"
        titleTop={titleTop}
        titleBottom={titleBottom}
      >
        {intl.messages['CareerHeader.text'] && intl.formatMessage({ id: 'CareerHeader.text' })}
      </HeaderText>
      <SortBar resultsTotal={total} searchParams={searchParams} />
      <Block beforeContent={<BlogFilter pageType="career" searchParams={searchParams} resultsTotal={total} />} align="right" contentSize="s" type="filter">
        <ArticleList>
          {total > 0 ? articles : <NoResults />}
        </ArticleList>
        <Pager previous={pager.previous} pagesList={pager.pages} next={pager.next} />
      </Block>
    </div>
  );
}

export default injectIntl(withSearch(Career));
